export default __webpack_public_path__ + "static/media/KW.cc292e4e.svg";